<app-layout>
  <div class="row">
    <div class="col-12">
      <div class="card p-0">
        <div class="card-header">
          <h3 class="card-title">Şubeler</h3>
          <div class="card-options">
            <div class="btn btn-sm btn-pill btn-success" (click)="new()">Yeni Şube</div>
          </div>
        </div>
        <div class="table-responsive" *ngIf="subeler">
          <table class="table card-table table-vcenter text-nowrap datatable">
            <thead>
            <tr>
              <th class="w-1">Id</th>
              <th>İsim</th>
              <th>Talep Serisi</th>
              <th>Teslimat Adresi</th>
              <th>Malzeme Teslim Alındı Mail Adresi</th>
              <th>Sipariş Oluşturuldu Mail Adresi</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let s of subeler">
              <td><span class="text-muted">{{s.id}}</span></td>
              <td>{{s.isim}}</td>
              <td>{{s.talepSeri}}</td>
              <td>{{s.teslimatAdresi}}</td>
              <td>{{s.satinAlmaMailAdresi}}</td>
              <td>{{s.siparisOlusturulduMailAdresi}}</td>
              <td class="text-right">
                <div class="btn btn-sm btn-success" (click)="incele(s)">İncele</div>
                <div class="btn btn-sm btn-danger ml-3" (click)="kaldir(s)">Kaldır</div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</app-layout>
